module.exports = __webpack_public_path__ + "img/Twist20.c98c2c94.jpg";